import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { libraryShape, availabilityShape } from '@bibliocommons/bc-prop-types';
import AvailabilityStatus from '@bibliocommons/availability-status';
import { ChevronLink } from '@bibliocommons/base-links';
import ProbeLogo from '@bibliocommons/shared-probe-logo';

import './ConnectedLibraryPanel.scss';

export class ConnectedLibraryHoldAvailability extends React.PureComponent {
  renderAvailabilityText() {
    return this.props.availability.get('localisedStatus') ? (
      <AvailabilityStatus
        status={this.props.availability.get('localisedStatus')}
        rollUpStatus={this.props.availability.get('statusType')}
        availabilityLocationType={this.props.availability.get('availabilityLocationType')}
      />
    ) : (
      <FormattedMessage id="check_title_for_availability" />
    );
  }

  render() {
    return (
      <div className="cp-connected-library-hold-availability">
        <div className="library-image">
          <ProbeLogo circled small siteId={this.props.library.get('siteId')} />
        </div>
        <div className="holdings-info">
          <ChevronLink href={this.props.bibUrl} dataKey="connected-library-link" className="library-name">
            <span>{this.props.library.get('fullName')}</span>
          </ChevronLink>
          {this.renderAvailabilityText()}
        </div>
      </div>
    );
  }
}

ConnectedLibraryHoldAvailability.propTypes = {
  bibUrl: PropTypes.string.isRequired,
  library: libraryShape.isRequired,
  availability: availabilityShape.isRequired
};

export default ConnectedLibraryHoldAvailability;
